import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const Reservations = () => {
  const history = useHistory();
  const [reservations, setReservations] = useState([]);

  const getReservations = async () => {
    try {
      const response = await axios.get(
        "https://mtrip-dynamic.herokuapp.com/reservations/"
      );
      setReservations([...response.data]);
    } catch (err) {
      console.log(err.response);
    }
  };

  useEffect(() => {
    getReservations();
  }, []);

  return (
    <div className="container mt-5" style={{ height: "100vh" }}>
      <h1> Your Reservations</h1>
      <hr />
      <table className="table">
        <thead>
          <tr>
            <th>Transaction ID</th>
            <th>Booking Name</th>
            <th>Adventure</th>
            <th>Person(s)</th>
            <th>Date</th>
            <th>Price</th>
            <th>Booking Time</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {reservations.map((reservation) => (
            <tr>
              <td>{reservation.id}</td>
              <td>{reservation.name}</td>
              <td>{reservation.adventureName}</td>
              <td>{reservation.person}</td>
              <td>{reservation.date}</td>
              <td>{reservation.price}</td>
              <td>{reservation.time}</td>
              <td>
                <button
                  className="btn btn-warning"
                  onClick={() =>
                    history.push(`/adventure-detail/${reservation.adventure}`)
                  }
                >
                  visit Adventure
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Reservations;
